export const defaultConfig = {
  key: 'ui-showcase1', // 每个ui组件必须有
  type: 'ui-showcase1', //
  images: {
    showcaseBg: ['showcase-bg1', 'showcase-bg2'],
    showcaseMask: 'showcase-mask',
    showcaseChipMask: 'showcase-my-chip-mask',
  }, // 每个组件的配置都统一放到images中管理
  layout: {
    // 布局相关的配置统一放到layout中
    containerWrapper: {
      pc: 'x',
      pt: '353',
    },
    swiperWrapper: {
      wh: '327 106',
      pt: '38',
      pl: '14',
    },
    itemWrapper: {
      wh: '69 106',
    },
    chipWrapper: {
      pc: 'x',
      pb: '-395',
    },
    chipTextWrapper: {
      f: '14 #fff 400',
      wh: '51 17',
      lh: '17',
      pl: '118',
      pt: '8',
    }, // 单个ui组件wrapper的ui配置 q-section相关的东西都能进行配置
  },
  config: {
    api: '/api/activities/general/lottery_pool/list',
    componentIds: [1, 2],
    nameColor: '#FFFFFF',
    descColor: 'rgba(255, 255, 255, 0.60)',
    swiperOptions: {
      loop: false, // 无限轮播
      speed: 500,
      slidesPerView: 3.2,
      spaceBetween: 0,
      allowTouchMove: true, // 始终允许手动滑动
      autoplay: {
        delay: 3000, // 自动播放延迟时间（毫秒）
        disableOnInteraction: false, // 用户操作后不停止自动播放
        pauseOnMouseEnter: false, // 鼠标悬停时不暂停
      },
    },
  }, //每个ui组件的一些配置字段相关的东西
}

import request from '@/core/request'
import { useRoute } from 'vue-router'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

export const useShowcase = (uiMeta: any) => {
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const api = uiMeta?.config?.api || ''

  const { data: showcaseListData, refetch: refetchShowcaseList } = useQuery({
    queryKey: ['showcaseList', activity_code, api],
    queryFn: async () => {
      const res = await Promise.all(
        uiMeta.config.componentIds.map(async (componentId: any) => {
          return request.get(api, {
            activity_code,
            component_id: componentId,
          })
        })
      )
      return res
    },
  })

  const showcaseList = computed(() => {
    return showcaseListData.value?.map((item: any) => item.data.rewards)
  })

  const myChildList = computed(() => {
    return showcaseListData.value?.map((item: any) => item.data.current_point_total)
  })

  return {
    showcaseListData: showcaseList,
    refetchShowcaseList,
    myChildList,
  }
}
